import { Compass, Users, Cpu } from "lucide-react";

const items = [
  {
    icon: Compass,
    title: "\u201CEvery big call still comes back to me.\u201D",
    body:
      "You're grateful for your team, but the big calls still come back to you. Your team has the potential, but not yet the frameworks, to think it through the way you would. Your time is better spent on vision and what grows the business, not buried in the numbers. So stepping away never really happens.",
    testid: "who-card-founders",
  },
  {
    icon: Users,
    title: "\u201CWe brought in help before. It didn\u2019t stick.\u201D",
    body:
      "Right now, decisions get made on instinct, vibes, or whoever spoke up last. You've brought in vendors and coaches before, and the team didn't fully buy in. What's missing is a grounded way to think things through that your people actually want to use.",
    testid: "who-card-leadership",
  },
  {
    icon: Cpu,
    title: "\u201CI don\u2019t need another AI pitch. I need someone to own it.\u201D",
    body:
      "Every week there's a new AI tool, a new framework, a new pitch. You don't need another AI architect. You need someone pragmatic who picks the right tools for the right moment, owns the rollout, and gets it used.",
    testid: "who-card-operators",
  },
];

export default function WhoIWorkWith() {
  return (
    <section id="who" data-testid="section-who" className="bg-paper">
      <div className="mx-auto max-w-[1100px] px-6 py-20 md:px-10 md:py-28 lg:py-32">
        <p className="eyebrow">Who I work with</p>
        <h2 className="section-heading mt-4 max-w-[760px]">
          A thinking partner for a defined stretch.
        </h2>
        <p
          data-testid="who-intro"
          className="mt-6 max-w-[680px]"
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontSize: "18px",
            lineHeight: 1.6,
            color: "rgba(26,58,79,0.78)",
          }}
        >
          Most clients come to me with some version of this on their mind.
        </p>

        <div className="mt-12 grid grid-cols-1 gap-10 md:mt-16 md:grid-cols-3 md:gap-12">
          {items.map(({ icon: Icon, title, body, testid }) => (
            <div key={testid} data-testid={testid} className="max-w-[340px]">
              <Icon
                aria-hidden="true"
                size={24}
                strokeWidth={1.5}
                color="#4A8FA8"
              />
              <h3
                className="mt-5 text-deep-lake"
                style={{
                  fontFamily: "Inter, Arial, sans-serif",
                  fontWeight: 500,
                  fontSize: "18px",
                  lineHeight: 1.4,
                }}
              >
                {title}
              </h3>
              <p
                className="mt-3"
                style={{
                  fontFamily: "Inter, Arial, sans-serif",
                  fontSize: "16px",
                  lineHeight: 1.65,
                  color: "rgba(26,58,79,0.78)",
                }}
              >
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
